export const DELIVERY_AREA = 'Delivery & Returns';
export const DELIVERY_INFO = 'Delivery info';
export const RETURNS = 'Returns';
